import { APP_CONFIG } from '../config/app';

export interface CoverageTown {
  name: string;
  /** Page locale dédiée, si elle existe. */
  to?: string;
}

const { routes } = APP_CONFIG;

/** Communes desservies, dans l'ordre d'affichage. */
export const COVERAGE_TOWNS: CoverageTown[] = [
  { name: 'Viry', to: routes.depannageViry },
  { name: 'Saint-Julien-en-Genevois', to: routes.depannageSaintJulien },
  { name: 'Genève', to: routes.depannageGeneve },
  { name: 'Annemasse', to: routes.depannageAnnemasse },
  { name: 'Gex', to: routes.depannagePaysDeGex },
  { name: 'Annecy', to: routes.depannageAnnecy },
  { name: 'Archamps', to: routes.depannageArchamps },
  { name: 'Neydens' },
  { name: 'Collonges-sous-Salève', to: routes.depannageCollonges },
];
